import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15 17.503h-1.667a2.5 2.5 0 0 1-2.5-2.5v-1.667a2.5 2.5 0 0 1 2.5-2.5H15a2.5 2.5 0 0 1 2.5 2.5v1.667a2.5 2.5 0 0 1-2.5 2.5m-1.667-5a.833.833 0 0 0-.833.833v1.667c0 .46.373.833.833.833H15c.46 0 .833-.373.833-.833v-1.667a.833.833 0 0 0-.833-.833z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M13.333 12.5H15v.833c0 .46-.373.834-.833.834 0-.167 0-.834-.373-.834",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  d: "M7.917 8.503a3.083 3.083 0 1 0 0-6.167 3.083 3.083 0 0 0 0 6.167Z",
  fill: "#fff",
  stroke: "currentColor",
  "stroke-width": "2"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("path", {
  d: "M10 5.42a2.083 2.083 0 1 1-4.167 0 2.083 2.083 0 0 1 4.167 0",
  fill: "#fff"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.667 5.418a3.75 3.75 0 1 1-.632-2.083h2.298a.833.833 0 1 1 0 1.666h-1.69q.024.205.024.417m-3.75 2.083a2.083 2.083 0 0 0 2.041-2.5H5.875a2.083 2.083 0 0 0 2.042 2.5M2.5 15.217A5.216 5.216 0 0 1 7.716 10h.102a4.8 4.8 0 0 1 2.138.505.833.833 0 0 1-.745 1.49 3.1 3.1 0 0 0-1.393-.328h-.102a3.55 3.55 0 0 0-3.55 3.549v1.173c0 .154.125.278.278.278h5.14a.833.833 0 1 1 0 1.667h-5.14A1.944 1.944 0 0 1 2.5 16.39z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6
  ]))
}